import { Globe } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

export const LanguageSelector = ({ testId = "language-selector", withIcon = true }) => {
  const { language, change, languages } = useLanguage();
  return (
    <div className="flex items-center gap-2">
      {withIcon ? <Globe className="h-4 w-4 text-[#8A97AD]" /> : null}
      <select
        data-testid={testId}
        value={language}
        onChange={(e) => change(e.target.value)}
        className="h-9 rounded-md border border-[#1D2637] bg-[#0E1523] px-2 font-mono text-xs text-[#C7D0DE] outline-none transition-colors focus:border-[#2563EB]"
      >
        {languages.map((l) => (
          <option key={l.code} value={l.code}>{l.label}</option>
        ))}
      </select>
    </div>
  );
};
